module.exports = __webpack_public_path__ + "static/poster-6739cfc75d7e016f2de07b0d79caa49b.png";